import React, { FC, memo, useContext } from "react";
import { useTranslation } from "react-i18next";

import { TaskContext } from "@/infrastructure/Tasks";
import { router } from "@/views/router";

import { RouteNavItem } from "./RouteNavItem";

export interface ITasksNavItemProps {
  onClick?: () => void;
  hasActiveState?: boolean;
}

export const TasksNavItem: FC<ITasksNavItemProps> = memo(({ onClick, hasActiveState = true }) => {
  const { t } = useTranslation("session");
  const tasksRoute = router.get("tasks");
  const { taskCount } = useContext(TaskContext);

  return (
    <RouteNavItem
      variant="icon"
      text={t("COMPONENTS.TOPBAR.BUTTON_TASKS")}
      icon="file-tasks"
      iconActive={hasActiveState ? "tasks_fill" : undefined}
      path={tasksRoute.path}
      exact={false}
      testName={tasksRoute.testName}
      badgeText={taskCount.all ? taskCount.all : undefined}
      onClick={onClick}
    />
  );
});
